import React, { useCallback } from 'react'
import { Container, Button } from '@sencha/ext-modern'
import { useEventHandler } from 'tyan/public/hooks'


const Handle = ({ imageSize, remain, valuesCount, onAddFiles, required, accept, enableCapture, enableJoyusingV1 }) => {
	const handleAddFiles = useEventHandler(() => Tyan.pubForm.getFileInput({
		onGetFiles: onAddFiles, accept, multiple: remain > 1, enableCapture, enableJoyusingV1, /* enablePaste: true */
	}))

	const handlePasteFile = useEventHandler(() => {
		const saveImg = () => new Promise((resolve, reject) => {
			Tyan.wsFrontEditor.SaveClipbrdImgBuff(({ ret }) => {
				const arr = ret.split('|').filter(o => o && !o.endsWith('\\'))
				arr.length ? resolve(arr) : reject('没有被复制的可用文件')
			})
		})

		saveImg()
			.then(onAddFiles)
			.catch(e => alert(e))
	})

	// const handlePasteFile = useEventHandler(() => {
	// 	navigator.clipboard.read()
	// 		.then(items => {
	// 			if (!(items[0] && items[0].types.length && items[0].types[0].startsWith('image/')))
	// 				return null
	// 			return items[0].getType(items[0].types[0])
	// 		})
	// 		.then(blob => {
	// 			if (!blob) return
	// 			const urlCreater = window.URL || window.webkitURL
	// 			const url = urlCreater.createObjectURL(blob)
	// 			const img = new Image()
	// 			img.onload = () => {
	// 				urlCreater.revokeObjectURL(url)
	// 				const canvas = document.createElement('canvas')
	// 				canvas.width = img.width
	// 				canvas.height = img.height
	// 				var ctx = canvas.getContext("2d");
	// 				ctx.drawImage(img, 0, 0)
	// 				canvas.toBlob(blob => {
	// 					const file = new File([blob], 'clip.jpg')
	// 					onAddFiles([file])
	// 				}, 'image/jpeg', 0.8)
	// 			}
	// 			img.src = url
	// 		})
	// 		.catch(reason => console.log('error:', reason))
	// })

	// hasWS 是否有前台控件
	const hasWS = Tyan.wsFrontEditor.Connected()
	const uiProps = required ? { ui: 'decline' } : {}
	const renderNormal = () => <Container layout='hbox' docked="bottom">
		<Button width="110px" /* margin="8 0 0 28"  */ iconCls="x-fa fa-upload" {...uiProps} text="上传文件" handler={handleAddFiles} />
		{hasWS && <Button width="110px" iconCls="x-fa fa-paste"  {...uiProps} text="粘贴" handler={handlePasteFile} /> || null}
	</Container>

	const renderImage = (valuesCount) => {
		// console.log('imageSize:', imageSize)
		return valuesCount
			? <Container key='second' layout='center' width={imageSize.width} /* margin='5' */>
				<Container layout='vbox'>
					<Button width="110px" iconCls="x-fa fa-upload"  {...uiProps} text="上传文件" handler={handleAddFiles} />
					{hasWS && <Button width="110px" iconCls="x-fa fa-paste"  {...uiProps} text="粘贴" handler={handlePasteFile} /> || null}
				</Container>
			</Container >
			: <Container key='first' {...imageSize} layout='hbox' margin='5'>
				{[['\uf03e', handleAddFiles], hasWS ? ['\uf0ea', handlePasteFile] : undefined].filter(o => o).map(([text, action]) => (
					<Container key={text} flex={1} layout='center' listeners={{ click: { element: 'bodyElement', fn: action } }}
						// style={{ fontFamily: 'FontAwesome', fontSize: `16px`, color: required ? '#c62828' : '#2196f3' }}
						style={{ fontFamily: 'FontAwesome', fontSize: `${Math.min(imageSize.width, imageSize.height) / 2 - 18}px`, color: 'lightgrey', cursor: 'pointer' }}
					>
						{text}
					</Container>
				))}
			</Container>
	}

	return imageSize ? renderImage(valuesCount) : renderNormal()
}

export default Handle